import { loadScript } from "./utils";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	for (const element of document.querySelectorAll("._cmpPreferences")) {
		element.addEventListener("click", (event) => {
			event.preventDefault();
			loadScript("clickio", "https://clickiocmp.com/t/consent_235086.js")
				.then(() => {
					if (
						window.__lxG__consent__ !== undefined &&
						window.__lxG__consent__.getState() !== null
					) {
						window.__lxG__consent__.showConsent();
					} else {
						alert(
							"This function only for users from European Economic Area (EEA)",
						);
					}
				})
				.catch((error) => {
					console.error("Error loading script:", error);
				});
		});
	}
});
